export var removeTypename = function (value) {
    if (value === null || value === undefined) {
        return value;
    }
    else if (Array.isArray(value)) {
        return value.map(function (v) { return removeTypename(v); });
    }
    else if (typeof value === "object") {
        var newObj_1 = {};
        Object.keys(value).forEach(function (key) {
            var v = value[key];
            if (key !== "__typename") {
                newObj_1[key] = removeTypename(v);
            }
        });
        return newObj_1;
    }
    return value;
};
// DO NOT:
// use ...rest since that will keep variables that should not be sent to the server and will fail the mutations
export function toPhoneNumberInput(val) {
    return {
        canBeUsedForSmsCodes: val.canBeUsedForSmsCodes,
        id: val.id,
        use: val.use,
        value: val.value
    };
}
export function toAddressInput(val) {
    return {
        apartmentNumber: val.apartmentNumber,
        city: val.city,
        co: val.co,
        country: val.country,
        id: val.id,
        postalCode: val.postalCode,
        primary: val.primary,
        streetAddress: val.streetAddress,
        type: val.type
    };
}
export function toEmailInput(val) {
    return {
        confirmed: val.confirmed,
        value: val.value,
        use: val.use
    };
}
//# sourceMappingURL=graphql.js.map